import type { PilotMathState } from '../pilotMath/types';
import type { PilotRuntimeRepository } from './runtimeRepository';

const PILOT_STORAGE_KEY = 'belajarku:pilot-math:v1';
export const PILOT_UPDATED_EVENT = 'belajarku:pilot-math:updated';

class LocalPilotRuntimeRepository implements PilotRuntimeRepository {
  readonly mode = 'local_pilot' as const;

  loadPilotState(): PilotMathState | null {
    if (typeof window === 'undefined') return null;
    const raw = window.localStorage.getItem(PILOT_STORAGE_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as PilotMathState;
    } catch {
      return null;
    }
  }

  savePilotState(state: PilotMathState): void {
    if (typeof window === 'undefined') return;
    window.localStorage.setItem(PILOT_STORAGE_KEY, JSON.stringify(state));
    this.notifyPilotUpdated();
  }

  clearPilotState(): void {
    if (typeof window === 'undefined') return;
    window.localStorage.removeItem(PILOT_STORAGE_KEY);
    this.notifyPilotUpdated();
  }

  notifyPilotUpdated(): void {
    if (typeof window === 'undefined') return;
    window.dispatchEvent(new CustomEvent(PILOT_UPDATED_EVENT));
  }
}

export const localPilotRuntimeRepository = new LocalPilotRuntimeRepository();
